import {Component, EventEmitter, forwardRef, Input, Output, ViewEncapsulation} from '@angular/core';
import {CurrencyPipe} from '@angular/common';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

/**
 * @group Price
 * @component Price
 * @description Standard price component in with currency pipe support
 */
@Component({
  selector: 'la-price',
  template: `
    <div class="la-price">
      <la-text-input>
        <input laInput [position]="position" [borderRadiusNone]="borderRadiusNone" [borderNone]="borderNone"
               [placeholder]="placeHolder" class="la-price__input" (keypress)="allowNumberOnly($event)"
               (blur)="setFormattedValue()" value="{{value}}" [(ngModel)]="value" name="price">
      </la-text-input>
    </div>
  `,
  styles: [`
    .ng-dirty.ng-invalid .la-price .la-text-input .la-text-input-floating.ng-touched,.ng-invalid.ng-dirty .la-price .la-text-input .la-text-input-floating.ng-touched{border:1px solid #fa8091}.la-price{display:inline-block;width:100%}
  `],
  encapsulation: ViewEncapsulation.None,
  providers: [CurrencyPipe, {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => LaPriceComponent),
    multi: true
  }]
})
export class LaPriceComponent  implements ControlValueAccessor {
  value: string;
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  private _symbol = '$';
  private _digitsInfo = '0.2-2';
  private _currencyCode = 'USD';
  private _placeHolder = 'Price';
  private _position: string;
  private _borderNone: string[] = [];
  private _borderRadiusNone: string[] = [];

  constructor(private _cp: CurrencyPipe) {
  }

  get currencyCode(): string {
    return this._currencyCode;
  }

  @Input()
  set currencyCode(currencyCode: string) {
    this._currencyCode = currencyCode;
  }

  get borderNone(): string [] {
    return this._borderNone;
  }

  @Input()
  set borderNone(borderNone: string[]) {
    this._borderNone = borderNone;
  }

  get placeHolder(): string {
    return this._placeHolder;
  }

  @Input()
  set placeHolder(placeHolder: string) {
    this._placeHolder = placeHolder;
  }

  get borderRadiusNone(): string [] {
    return this._borderRadiusNone;
  }

  @Input()
  set borderRadiusNone(borderRadiusNone: string[]) {
    this._borderRadiusNone = borderRadiusNone;
  }

  get position(): string {
    return this._position;
  }

  @Input()
  set position(position: string) {
    this._position = position;
  }

  get digitsInfo(): string {
    return this._digitsInfo;
  }

  @Input()
  set digitsInfo(digitsInfo: string) {
    this._digitsInfo = digitsInfo;
  }

  get symbol(): string {
    return this._symbol;
  }

  @Input()
  set symbol(symbol: string) {
    this._symbol = symbol;
  }

  setFormattedValue(): void {
    let value = '';
    if (this.value) {
      // remove all alpha and other char
      value = this.value.toString().replace(/[^\d.-]/g, '');
      this.value = this._cp.transform(value, this.currencyCode, this.symbol, this.digitsInfo);
    }
    this.onChange.emit(value);
    this.propagateChange(value);
  }

  allowNumberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    let isNumber = true;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      isNumber = false;
    }
    return isNumber;
  }

  /* code for value accessor start */
  writeValue(value: any): void {
    if (value) {
      this.value = value
      this.setFormattedValue();
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  propagateChange = (_: any) => {
  };
}
